import SimpleTable from "@/components/SimpleTable";
import { handleCompanyName } from "@/lib/handleName";
import { Company } from "@/schema/console/companies/Company";
import CompanyTableRowActions from "@/src/console/(auth)/companies/_components/CompanyTableRowActions";
import UpdateAssessmentDateDialog from "@/src/console/(auth)/companies/_components/UpdateAssessmentDateDialog";
import UpdateCompanyStatusDialog from "@/src/console/(auth)/companies/_components/UpdateCompanyStatusDialog";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

interface CompanyTableProps {
  data: Company[];
  isLoading: boolean;
}

function CompanyTable({ isLoading, data }: CompanyTableProps) {
  const { t } = useTranslation();

  return (
    <>
      <SimpleTable
        isLoading={isLoading}
        data={data}
        columns={[
          {
            key: "name",
            label: t("company-name"),
            render: ({ id, company_name }) => (
              <div className="flex h-[42px] items-center">
                <span>{handleCompanyName(id, company_name)}</span>
              </div>
            ),
          },
          {
            key: "assessmentDate",
            label: t("assessment-date"),
            render: ({ start_date, end_date }) => (
              <div>
                <div>{`${t("start-date")} : ${start_date ? format(start_date, t("date-format")) : "---"}`}</div>
                <div>{`${t("end-date")} : ${format(end_date ?? "", t("date-format"))}`}</div>
              </div>
            ),
          },
          {
            width: "400px",
            key: "status",
            label: t("status"),
            render: ({ status: { name } }) => name,
          },
          {
            width: "200px",
            key: "action",
            label: "",
            render: (company) => <CompanyTableRowActions company={company} />,
          },
        ]}
      />
      <UpdateCompanyStatusDialog />
      <UpdateAssessmentDateDialog />
    </>
  );
}

export default CompanyTable;
